import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

// Define a service using a base URL and expected endpoints
export const labourBookingApi = createApi({
  reducerPath: 'labourBookingApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['labourBooking'],
  endpoints: (builder) => ({
    lineUpLabourWithBooking: builder.mutation({
      query({ labourId, bookingId, status, token }) {
        return {
          url: `${spotFinder.labourBookingController.lineupLabourWithBooking}/${labourId}/${bookingId}/${status}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${token}` },  
        };
      },
    }),
    updateBookingStatusByLabour: builder.mutation({
      query({ bookingId, status, token }) {
        return {
          url: `${spotFinder.labourBookingController.updateBookingStatusByLabour}/${bookingId}/${status}/status`,
          method: 'GET',
          headers: { Authorization: `Bearer ${token}` },
        };
      },
    }),
  }),
});

export const {
  useLineUpLabourWithBookingMutation,
  useUpdateBookingStatusByLabourMutation,
} = labourBookingApi;
